import { getSentrySdk, getServiceTag } from './registry';

export interface FrontendObservabilityUser {
	id?: string;
	email?: string;
	name?: string;
}

export interface SetFrontendContextInput {
	user?: FrontendObservabilityUser;
	communityId?: string;
	communityName?: string;
	/** Community slug from URL `/c/:readableId/...` (e.g. logged-out open pages). */
	readableId?: string;
}

function normalizeTag(value: string | undefined): string | undefined {
	if (value === undefined || value === null) return undefined;
	const s = String(value).trim();
	return s === '' ? undefined : s;
}

/**
 * Sets Sentry user + scope tags for the browser session.
 * Tags: id, email, name, communityId, communityName, readableId, service, domain (tenant removed).
 */
export function setFrontendContext(input: SetFrontendContextInput = {}): void {
	const sdk = getSentrySdk();
	if (!sdk) return;

	const u = input.user;
	if (u?.id || u?.email || u?.name) {
		sdk.setUser({
			id: normalizeTag(u.id),
			email: normalizeTag(u.email),
			username: normalizeTag(u.name),
		});
	}

	const domain = typeof window !== 'undefined' ? window.location.host : '';

	const tags: Record<string, string | undefined> = {
		domain: domain ? domain : undefined,
		service: getServiceTag()
	};
	if ('communityId' in input) {
		tags.communityId = normalizeTag(input.communityId);
	}
	if ('communityName' in input) {
		tags.communityName = normalizeTag(input.communityName);
	}
	if ('readableId' in input) {
		tags.readableId = normalizeTag(input.readableId);
	}
	if (u) {
		tags.id = normalizeTag(u.id);
		tags.email = normalizeTag(u.email);
		tags.name = normalizeTag(u.name);
	}
	sdk.setTags(tags);
}

export function clearFrontendContext(): void {
	const sdk = getSentrySdk();
	if (!sdk) return;

	sdk.setUser(null);

	const domain = typeof window !== 'undefined' ? window.location.host : '';

	sdk.setTags({
		id: undefined,
		email: undefined,
		name: undefined,
		communityId: undefined,
		communityName: undefined,
		readableId: undefined,
		domain: domain ? domain : undefined,
		service: getServiceTag(),
	});
}
